import * as types from '../../mutation-types'
import users from '../../../api/users'

const state = {
  user: JSON.parse(localStorage.getItem('user-store-user') || '{}'),
  token: localStorage.getItem('user-store-token') || '',
  loginStatus: !!localStorage.getItem('user-store-token'),
  userPDQTerminals: []
}
state.userPDQTerminals = ((state.user.data || {}).terminals || []).sort(a => a.tid)
// getters
const getters = {
  user: state => state.user,
  token: state => state.token,
  loginStatus: state => state.loginStatus,
  userPDQTerminals: state => state.userPDQTerminals
}

const actions = {
  login ({commit, state}, user) {
    commit(types.LOADING_START)
    commit(types.SIGN_IN)
    // Now call the login api
    return new Promise((resolve, reject) => {
      users.login(user)
        .then((user) => {
          if (user.status === 'Failed') {
            commit(types.SIGN_IN_FAILURE, user.error)
            reject(user.error)
          }
          commit(types.SIGN_IN_SUCCESS, user)
          commit(types.SET_USER_PDQ_TERMINALS, user.data.terminals)
          resolve(user)
        })
        .catch((reason) => {
          commit(types.SIGN_IN_FAILURE, user.error)
          reject(user.error)
        })
        .finally(() => {
          commit(types.LOADING_END)
        })
    })
  },
  logOut ({commit}) {
    commit(types.LOGOUT)
  }
}

const mutations = {
  [types.SET_USER_PDQ_TERMINALS] (state, tids) {
    state.userPDQTerminals = tids.sort(a => a.tid)
  },
  [types.SIGN_IN] (state) {
    state.loginStatus = false
    state.user = {}
    localStorage.setItem('user-store-user', '{}')
    localStorage.setItem('user-store-token', '')
  },
  [types.SIGN_IN_SUCCESS] (state, user) {
    state.user = user
    localStorage.setItem('user-store-user', JSON.stringify(user))
    console.log(user)
    state.token = user.authToken
    localStorage.setItem('user-store-token', user.authToken)

    state.loginStatus = true
  },
  [types.SIGN_IN_FAILURE] (state, reason) {
    state.loginStatus = false
    state.loginFailedStatus = reason.toString()
  },
  [types.LOGOUT] (state) {
    state.user = null
    state.token = null
    state.loginStatus = false
    console.log(state)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user/index.js